module.exports = __webpack_public_path__ + "static/img/COVID19-01.9c2aaa7e.svg";